import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const CityAdd = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    city: "",
    state: "",
    country: "",
    status: "Active",
  });

  const countries = ["India", "USA", "Canada"];
  const states = {
    India: ["Maharashtra", "Gujarat", "Delhi"],
    USA: ["California", "Texas", "New York"],
    Canada: ["Ontario", "Quebec", "British Columbia"],
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "country") {
      setFormData((prev) => ({ ...prev, state: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted City Data:", formData);
    // TODO: Send formData to backend API

    // Reset or redirect
    navigate("/city-master");
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="mb-0 fw-semibold">Add City</h4>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="row">
          <div className="col-xl-6">
            <div className="card">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {/* Country */}
                  <div className="mb-3">
                    <label className="form-label">Country</label>
                    <select
                      name="country"
                      className="form-select"
                      value={formData.country}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Country --</option>
                      {countries.map((c, i) => (
                        <option key={i} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* State */}
                  <div className="mb-3">
                    <label className="form-label">State</label>
                    <select
                      name="state"
                      className="form-select"
                      value={formData.state}
                      onChange={handleChange}
                      required
                      disabled={!formData.country}
                    >
                      <option value="">-- Select State --</option>
                      {formData.country &&
                        states[formData.country]?.map((s, i) => (
                          <option key={i} value={s}>
                            {s}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* City Name */}
                  <div className="mb-3">
                    <label className="form-label">City Name</label>
                    <input
                      type="text"
                      name="city"
                      className="form-control"
                      placeholder="Enter city name"
                      value={formData.city}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Status */}
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      name="status"
                      className="form-select"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>

                  {/* Submit */}
                     <div className="text-end">
                    <button type="submit" className="btn btn-success">
                      Add City
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary ms-2"
                      onClick={() => navigate("/city-list")}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CityAdd;
